module.exports = __webpack_public_path__ + "static/media/user.78f630fe.svg";